import React from 'react';
import { GitBranch, Link2 } from 'lucide-react';
import Tooltip from '../ui/Tooltip';

/**
 * The detail card of something not in a repository yet (Git page redesign,
 * 05.10.2026): what connecting gives, and the one way in. The dialog it
 * opens picks the account and creates the repository when it is not there —
 * an existing one is used as it is.
 */
export default function GitConnectEmpty({ text, onConnect, disabled = false, hint = '' }) {
  const button = (
    <button
      type="button"
      className="git-btn git-btn--primary git-btn--large"
      disabled={disabled}
      onClick={onConnect}
      aria-label="Connect to a repository"
    >
      <Link2 size={14} />
      Connect to a repository
    </button>
  );
  return (
    <div className="git-connect" data-testid="git-connect-empty">
      <span className="git-connect-icon" aria-hidden>
        <GitBranch size={22} />
      </span>
      <div className="git-connect-text">
        <span className="git-connect-title">Not in a repository yet</span>
        <span className="git-connect-sub">{text}</span>
      </div>
      {hint ? (
        <Tooltip content={hint} side="bottom">
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
}
